import {Injectable} from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';

declare const angular: any;

@Injectable({
  providedIn: 'root'
})
export class ClientRulesService {
  ajsClientRulesService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsClientRulesService = injector.get('ClientRulesService');
  }

  getSharedValue(key: string) {
    return this.ajsClientRulesService.getSharedValue(key);
  }

  setSharedValue(key: string, value: any) {
    return this.ajsClientRulesService.setSharedValue(key, value);
  }
}
